<template>
  <input
    v-cursor-position
    :value="displayValue"
    type="tel"
    :data-position="position"
    :data-previous="previous"
    @input="formatOnType"
    @blur="formatOnBlur"
  >
</template>

<script>
import { format, unformatToFixed, formatToFixed } from '../utils/formatUtils';

export default {
  name: 'Currency',
  directives: {
    cursorPosition: {
      update(e) {
        let diff = 0;
        if (e.dataset.previous.length === e.value.length - 1) {
          diff = 1;
        }
        if (e.dataset.previous.length === e.value.length + 1) {
          diff = -1;
        }
        if (e.selectionEnd !== e.dataset.position) {
          e.selectionEnd = Number(e.dataset.position) + diff;
        }
      },
    },
  },
  props: {
    value: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      previous: '',
      displayValue: '',
      position: 0,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        const formatted = format(newValue);
        if (formatted !== this.displayValue) {
          this.displayValue = formatted;
        }
      },
    },
  },
  methods: {
    formatOnType(evt) {
      this.previous = evt.target.value;
      this.position = evt.target.selectionStart;
      this.displayValue = format(evt.target.value);
      this.$emit(
        'input',
        this.displayValue ? parseFloat(unformatToFixed(this.displayValue)) : 0
      );
    },
    formatOnBlur(evt) {
      this.displayValue = formatToFixed(evt.target.value);
    },
  },
};
</script>

<style>
</style>
